import React from 'react';
import { withRouter } from 'utils/withRouter';
import styled from 'styled-components';
import Table from 'common/table/legacy-table';
import { Icon, Flex, Div } from 'ui';
import { Button, Select, Popover } from 'antd';
import PropTypes from 'prop-types';
import Spinner from 'common/spinner/components/spinner';
import { injectIntl } from 'react-intl';
import settingsConfig from '../../settings-config';

const { Option } = Select;

export const StyledButton = styled(Button)`
  background-color: ${p => p.theme.colors.theme};
  width: 34px;
  box-shadow: none !important;
  vertical-align: sub;
  &:hover {
    background-color: ${p => p.theme.colors.theme};
    width: 34px;
    opacity: 0.7;
  }
  &:focus {
    background-color: ${p => p.theme.colors.theme};
    width: 34px;
  }
`;

const StyledIcon = styled(Icon)`
  color: white;
`;

export const StyledInfoIcon = styled(Icon)`
  margin-left: 5px;
  vertical-align: sub;
`;

export const StyledRoleDropdown = styled(Select)`
  margin-top: 2px;
  width: 200px;
  font-weight: 400;
  font-size: 16px;
`;

export const StyledOption = styled(Option)`
  ${p => p.hidden ? 'display: none;' : ''}
`;

const UserManagementTable = ({
  tableData,
  updateUser,
  isLoading,
  fetchMore,
  roles,
  intl,
  deleteUser,
  disabled,
  tooltipText,
}) => {
  const handleDeleteButtonClick = (e, id) => {
    e.stopPropagation();
    deleteUser(id, false);
  };

  const getColumns = () => [
    {
      label: '',
      dataIndex: 'id',
      renderValueFn: id =>
        <StyledButton
          onClick={e => handleDeleteButtonClick(e, id)}
          shape='circle'
          disabled={disabled}
        >
          <StyledIcon type='trash-alt' />
        </StyledButton>,
      width: '40px',
    },
    {
      label: intl.formatMessage({ id: 'userManagement.NAME' }),
      dataIndex: 'displayName',
    },
    {
      label: intl.formatMessage({ id: 'userManagement.ACCESS_RIGHTS' }),
      dataIndex: 'role',
      renderValueFn: (role, row) =>
        <Flex jcfs>
          <StyledRoleDropdown
            defaultValue={row.role.id}
            listItemHeight={10}
            onSelect={newRole => updateUser(row.id, newRole)}
            // eslint-disable-next-line max-len
            disabled={disabled || (!row.role.isAssignable && row.role.id !== settingsConfig.roles.writeuser)}
            showArrow={row.role.isAssignable || row.role.id === settingsConfig.roles.writeuser}
          >
            {
              !row.role.isAssignable && row.role.id !== settingsConfig.roles.writeuser ?
                <Option value={row.role.id}>{row.role.description}</Option> :
                roles?.map(r =>
                  <StyledOption key={r.id} value={r.id} hidden={!r.isAssignable}>
                    {r.description}
                  </StyledOption>,
                )
            }
          </StyledRoleDropdown>
          <Popover
            placement='rightBottom'
            content={tooltipText}
            overlayClassName='permissions-tooltip'
          >
            <div>
              <StyledInfoIcon type='info-circle' onClick={e => e.preventDefault()} />
            </div>
          </Popover>
        </Flex>,
      width: '400px',
    },
    {
      label: intl.formatMessage({ id: 'userManagement.LAST_ACTIVITY' }),
      dataIndex: 'lastActivity',
      format: 'date',
      width: '400px',
    },
  ];

  return (
    <Div marginTop={20}>
      {isLoading ?
        <Spinner title={intl.formatMessage({ id: 'common.LOADING_USERS' })} /> :
        <Table
          columns={getColumns()}
          data={tableData?.data || []}
          rowKey='id'
          hasRowSelector={false}
          pageSize={tableData?.data?.length}
          isLoading={false}
          customRemainingItems={() => tableData?.totalDataCount - tableData?.data?.length}
          customMoreFunction={fetchMore}
          customMoreCount={20}
        />
      }
    </Div>
  );
};
UserManagementTable.propTypes = {
  tableData: PropTypes.object,
  updateUser: PropTypes.func,
  isLoading: PropTypes.bool,
  fetchMore: PropTypes.func,
  roles: PropTypes.array,
  intl: PropTypes.object,
  deleteUser: PropTypes.func,
  disabled: PropTypes.bool,
  tooltipText: PropTypes.string,
};

export default withRouter(injectIntl(UserManagementTable));
